import type { ColumnsConfig, ResolvedColumnsConfig } from './types';

export const DEFAULT_COLUMNS: ResolvedColumnsConfig = {
  mobile: 2,
  tablet: 3,
  desktop: 4,
};

export function useResponsiveMediaColumns(
  columns: Readonly<Ref<ColumnsConfig>>,
) {
  const { $viewport } = useNuxtApp();

  const resolvedColumns = computed<ResolvedColumnsConfig>(() => ({
    ...DEFAULT_COLUMNS,
    ...columns.value,
  }));

  const columnsCount = computed(() => {
    if ($viewport.isGreaterOrEquals('desktop')) {
      return resolvedColumns.value.desktop;
    }

    if ($viewport.match('xs')) {
      return resolvedColumns.value.mobile;
    }

    return resolvedColumns.value.tablet;
  });

  return {
    columnsCount,
    resolvedColumns,
  };
}
